import config from "../config";
import axios from "../config/axios";

export const signin = (creds) => {
  return axios.post(config.apiEndPoint + "/auth/signin", creds);
};
export const storeGuestUserData = (data) => {
  return axios.post(config.apiEndPoint + "/auth/guest", data);
};
export const getCurrentUser = () => {
  axios.setAuthHeader();
  return axios.get(config.apiEndPoint + "/auth/currentUser");
};
export const logout = () => {
  axios.setAuthHeader();
  return axios.get(config.apiEndPoint + "/auth/logout");
};

/** Clears all localStorage (auth and app state) on logout */
export const clearStorageOnLogout = () => {
  localStorage.clear();
};
